import React, { useContext, useEffect, useRef } from "react";
import { AppbarContentContext } from "../../../commons/routing/appbar/AppbarContentProvider";
import { useStyles } from "./PlayerCoursesStyles.css";
import PlayerCoursePlaylistOverview from "./course_overview/PlayerCoursePlaylistOverview";
import useRegisteredCourses from "../util/useRegisteredCourses";
import LoadingProgressIndication from "../../../commons/elements/progress/loading/LoadingProgressIndication";
import { InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { FormattedMessage, useIntl } from "react-intl";

// Parent component for the player course section
const PlayerCoursesSection = () => {
    const { setCurrentAppbarContent } = useContext(AppbarContentContext);
    const intl = useIntl();
    const {
        courses,
        activeCourse,
        activeCoursePlaylists,
        loadingCourses,
        loadingPlaylist,
        handleChange,
    } = useRegisteredCourses();

    const classes = useStyles();

    console.log(activeCourse);
    console.log(new Date());
    const getCourseListDropdown = () => {
        if (loadingCourses || courses?.length === 0) {
            return <></>;
        }
        return (
            <FormControl className={classes.formControlChart}>
                <Select
                    style={{ color: "white", borderRadius: 30, borderColor: "grey" }}
                    variant="outlined"
                    id="reg-statistics-course-input"
                    value={activeCourse}
                    onChange={(event) => handleChange(event)}
                >
                    {courses?.map((course) => (
                        <MenuItem value={course}>
                            {course.name} ({intl.formatDate(course.fromDate)} -{" "}
                            {intl.formatDate(course.toDate)})
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: (
                <FormattedMessage
                    id={"app.game.courses.overview.appbar.header"}
                    defaultMessage={"Courses "}
                />
            ),
            description: (
                <FormattedMessage
                    id={"app.game.courses.overview.appbar.description"}
                    defaultMessage={"All courses you are enrolled to"}
                />
            ),
            actions: <>{getCourseListDropdown()}</>,
        });
    }, [courses, activeCourse]);

    if (loadingCourses) {
        return (
            <LoadingProgressIndication
                text={intl.formatMessage({
                    id: "app.game.loading.courses",
                    defaultMessage: "Loading courses...",
                })}
            />
        );
    }

    if (loadingPlaylist && activeCourse !== undefined) {
        return (
            <LoadingProgressIndication
                text={intl.formatMessage({
                    id: "app.game.loading.playlists",
                    defaultMessage: "Loading playlists...",
                })}
            />
        );
    }

    return (
        <div>
            <PlayerCoursePlaylistOverview
                playlists={activeCoursePlaylists}
                course={activeCourse}
            />
        </div>
    );
};

export default PlayerCoursesSection;
